import { ca } from '@cian/analytics';

export function trackGoToApplicationForm(): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Map',
    action: 'Click',
    label: 'GoToApplicationForm/main',
  });
}
